<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['lot.no']" placeholder="business.label.lot" @clear="refresh()" @keydown.native.enter="refresh()"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh()"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="200"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="lot.no" title="business.label.lot" width="150"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="detail.receivingman" title="business.label.receiver" width="150"/>
        <vxe-column field="detail.invoiceQuantity" title="business.label.invoiceQuantity" width="150"/>
        <vxe-column field="detail.receivedQuantity" title="business.label.receivedQuantity" width="150"/>
        <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="150"/>
        <vxe-column field="detail.rejectedQuantity" title="business.label.rejectedQuantity" width="150"/>
        <vxe-column field="detail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="150"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.modify" icon="vxe-icon-edit" status="primary" @click.stop="modify(row)"/>
            <vxe-button content="button.rollback" icon="vxe-icon-undo" status="error" @click.stop="rollback(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <modify-modal ref="modifyModal" @success="refresh()"/>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import ModifyModal from '@/views/inbound/modify/ModifyModal.vue'

export default {
  name: 'ModifyDetail',
  components: { ModifyModal },
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'no': ''
      },
      orderId: null,
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      if (!this.orderId) {
        return this.$message.warning('请选择一行单据再查询明细信息')
      }
      this.loading = true
      const args = {
        ...this.query,
        'order.id': this.orderId
      }
      findAll('receiptDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(id) {
      if (id) this.orderId = id
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.refresh()
    },
    clear() {
      this.data = []
    },
    modify(row) {
      this.$refs.modifyModal.open(row)
    },
    rollback(row) {
      const that = this
      this.$confirm({
        title: '是否确认验收回滚?',
        content: '验收回滚后需重新验收',
        onOk() {
          that.loading = true
          post(api.receivingReceiverRollback, {}, { id: row.detail.id }).then(res => {
            if (res.success) {
              that.$message.success('回滚成功')
              that.fetch()
            }
          }).finally(() => that.loading = false)
        },
        onCancel() {
        },
        centered: true
      })
    }
  }
}
</script>